import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { uniqueId } from '@co-3/ctrl-ui/common';
import { Observable, of } from 'rxjs';
import { InsurenetInterfaceService } from '@core';
import { InsuredObjectFormControl } from '../../../models/insured-object-form-config';

interface SelectOption {
    label: string | number;
    /* eslint-disable-next-line @typescript-eslint/no-explicit-any */
    value: any;
}

@Component({
    selector: 'app-insured-object-dynamic-form',
    templateUrl: './insured-object-dynamic-form.component.html',
    standalone: false,
})
export class InsuredObjectDynamicFormComponent implements OnChanges, OnInit {
    @Input()
    public formGroup: FormGroup;
    @Input()
    public formControlsConfig: InsuredObjectFormControl[];
    @Input()
    public insuranceTypeId: number;

    public id = uniqueId();
    public obs: { [key: string]: Observable<SelectOption[]> } = {};
    public constructor(private insurenetInterface: InsurenetInterfaceService) {}

    public get controls(): { [key: string]: FormControl } {
        return this.formGroup.controls as { [key: string]: FormControl };
    }

    public getErrorType(
        errorMessageConfig: string | { [key: string]: string } | undefined,
    ): 'generic' | 'specific' | 'none' {
        return typeof errorMessageConfig !== 'undefined'
            ? typeof errorMessageConfig === 'string'
                ? 'generic'
                : 'specific'
            : 'none';
    }

    public ngOnChanges(changes: SimpleChanges): void {
        if (changes['formControlsConfig']) {
            this.collectObservables();
        }
    }

    public ngOnInit(): void {
        this.focusOnFirstInput();
    }

    private focusOnFirstInput(): void {
        const firstId = `${Object.keys(this.controls)[0]}_${this.id}`;
        // We need to wait for the input to be in the dom before focussing on it
        setTimeout(() => {
            const element = document.getElementById(firstId) as HTMLElement;
            element?.focus();
        }, 1);
    }

    private collectObservables(): void {
        this.formControlsConfig.forEach((controlConfig) => {
            this.obs[controlConfig.name] = ((
                config?: string | ((formGroup?: FormGroup) => Observable<SelectOption[]>),
            ): Observable<SelectOption[]> => {
                if (typeof config === 'function') {
                    return config(this.formGroup);
                } else if (typeof config === 'string' && typeof this.insurenetInterface[config] === 'function') {
                    try {
                        return this.insurenetInterface[config]([...controlConfig.optionsParams]);
                    } catch (err) {
                        console.error(err);
                    }
                }
                return of([]);
            })(controlConfig.options);
        });
    }
}
